export const BookmarkedVaultsListHero = () => {
  return (
    <div className="mx-auto hidden text-center sm:flex">
      <h1 className="font-normal text-xl leading-5 sm:text-3xl">Your favorite yield onchain</h1>
    </div>
  )
}
